// @ vendors
import { APIPost } from 'utilities/APIRequestHelper'
import get from 'lodash/object/get'
import { i18n } from 'core/i18n';
const { formatText } = i18n;
// @ commons
import apiURLBuilder from 'core/apiURLBuilder';
// @ constants
import gdprConsentsActions from 'actions/gdprConsents';
// @actions
import {
    hireContractFailure,
    hireContractSuccess
} from 'actions/contracts';
import { setTermsAndCondsInfo } from 'actions/termsAndCondsInfo';
import signaturePatternActions from 'actions/signaturePattern';

const setDepositExpired = (dispatch, data, getState) => {
    const operationProcessId = getState().contractualPolling.get('operationProcessId');
    const immContracts = getState().contracts;
    const productInfo = immContracts.get('deposit_product');
    const productName = `${formatText(productInfo.get('context') + '-' + productInfo.get('name'))}` || '';
    const requestData = {
        header: {
            version: 3
        },
        query: {
            operationProcessId: operationProcessId,
            productName,
            ...data
        }
    };
    const contractType = immContracts.get('contract_type');
    const termsAndCondHiringData = [immContracts.get('hiring_data_contract').toJS()];

    return APIPost(dispatch, apiURLBuilder.getURL('hireDepositConfirmation'), requestData)
        .then(response => {
            const { oficina, digitodecontrol, numerodecuenta } = get(response, 'contratoDeposito') || {}
            response.depositContract = `${oficina.entidad}${oficina.oficina}${digitodecontrol}${numerodecuenta}`

            dispatch(hireContractSuccess(response));
            dispatch(setTermsAndCondsInfo(contractType, termsAndCondHiringData, operationProcessId));
        })
        .catch(response => {
            dispatch(hireContractFailure(response));
        });
};

const hireDepositExpired = params => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const data = Object.assign(params, { dataToken });
        dispatch(gdprConsentsActions.updateConsents(dataToken))
            .then(() => setDepositExpired(dispatch, data, getState))
            .catch(response => {
                if(!!response.error) {
                    setDepositExpired(dispatch, data, getState);
                } else {
                    throw response;
                }
            });
    };

    new Promise(function() {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

module.exports = {
    hireDepositExpired,
};
